@if (specialistEncounterVerifications && specialistEncounterVerifications.length > 0) {
  <div
    class="dates"
    >
    @for (verification of specialistEncounterVerifications; track verification; let i = $index) {
      <app-validate-specialist-encounter-verification
        [patientAttachment]="patientAttachment"
        [verification]="verification"
        [position]="i"
        (changeVerification)="onChange($event)"
        (removeVerification)="onRemove($event)"
        />
    }
  </div>
} @else {
  <div class="my-2">No specialist encounter dates found.</div>
}
@if (!collapsed) {
  <div class="my-2">
    <button [disabled]="addDisabled" class="btn btn-sm btn-primary" (click)="onAddClick($event)">
      <fa-icon class="text-white" [icon]="['fas', 'plus-circle']" /> Add Encounter Date
    </button>
  </div>
}
